import React from "react";
import { useTranslation } from "react-i18next";
import SectionHead from "./ui/SectionHead";
import { ArrowUpRight } from "./ui/Icons";

const ARTICLES = [
  {
    key: "africa",
    href: "https://africa.com/how-an-ai-app-is-helping-burundian-farmers-spot-crop-diseases-early/",
  },
  {
    key: "andika",
    href: "https://andikamagazine.net/elie-bubuyas-hyphen-tech-is-transforming-agriculture-and-business-in-burundi-through-ai/",
  },
  {
    key: "agora",
    href: "https://www.agorainternational.it/articles/burundi-mastering-the-worlds-assistant/",
  },
];

/**
 * Press index as a set of ruled rows rather than three shadowed cards —
 * closer to how a publication lists its own coverage, and it lets the
 * headlines run at a readable length instead of being clipped into boxes.
 */
export default function InTheNews() {
  const { t } = useTranslation();

  return (
    <section className="section bg-agri-paper">
      <div className="container-x">
        <SectionHead
          kicker={t("design.news.badge")}
          title={t("design.news.title")}
        />

        <ul>
          {ARTICLES.map((article) => (
            <li key={article.key}>
              <a
                href={article.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group grid grid-cols-1 gap-x-10 gap-y-3 border-b border-agri-rule py-8 transition-colors duration-300 ease-out hover:bg-agri-paper sm:py-10 lg:grid-cols-12 lg:px-4"
              >
                <p className="font-mono text-[0.6875rem] uppercase tracking-[0.12em] text-agri-clay lg:col-span-3 lg:pt-2">
                  {t(`design.news.articles.${article.key}.source`)}
                </p>

                <div className="lg:col-span-7">
                  <h3 className="text-balance font-display text-[1.25rem] font-semibold leading-[1.25] tracking-[-0.018em] text-agri-ink sm:text-[1.5rem]">
                    {t(`design.news.articles.${article.key}.title`)}
                  </h3>
                  <p className="mt-3 max-w-measureWide text-[0.9375rem] leading-[1.7] text-agri-ink80">
                    {t(`design.news.articles.${article.key}.desc`)}
                  </p>
                </div>

                <span className="flex items-start gap-2 font-mono text-[0.6875rem] uppercase tracking-[0.12em] text-agri-ink60 transition-colors group-hover:text-agri-ink lg:col-span-2 lg:justify-end lg:pt-2">
                  {t("design.news.readArticle")}
                  <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
